import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { notifications } from "@mantine/notifications";
import { roleTasksService } from "../../services/admin/roleTasks.service";

export function useRoleTasksAdmin() {
  return useQuery({
    queryKey: ["admin", "role-tasks"],
    queryFn: roleTasksService.getAll,
  });
}

export function useRoleTasksByRole(roleId?: string) {
  return useQuery({
    queryKey: ["admin", "role-tasks", roleId],
    queryFn: () => roleTasksService.getByRole(roleId!),
    enabled: !!roleId,
  });
}

export function useSetRoleTasks() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ roleId, taskIds }: { roleId: string; taskIds: string[] }) =>
      roleTasksService.setForRole(roleId, taskIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "role-tasks"] });
      notifications.show({
        title: "Success",
        message: "Role tasks updated successfully",
        color: "green",
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: "Error",
        message: error.response?.data?.error || "Failed to update role tasks",
        color: "red",
      });
    },
  });
}
